import { useQuery } from "@tanstack/react-query";
import { orpc } from "@/orpc/client";

/**
 * Subscription hook with aggressive caching.
 * Data is considered fresh for 5 minutes to avoid unnecessary refetches.
 */
export function useSubscription() {
	return useQuery({
		...orpc.billing.getSubscription.queryOptions(),
		staleTime: 5 * 60 * 1000, // 5 min - data stays fresh
		gcTime: 30 * 60 * 1000, // 30 min - keep in cache
	});
}

/**
 * Check if user can create a resource of the given type.
 * Returns limit info for displaying to users.
 */
export function useCanCreate(resource: "apps" | "partners" | "links") {
	const { data, isLoading } = useSubscription();

	if (!data || isLoading) {
		return { canCreate: true, usage: 0, limit: 0, isLoading: true };
	}

	const usage = data.usage[resource];
	const limit = data.limits[resource];

	return {
		canCreate: usage < limit,
		usage,
		limit,
		isLoading: false,
	};
}
